

const bowlingBags =  [
  {
    id: 1,
    bagName: "Edge Single Tote",
    warranty: "2-Year Limited Warranty",
    color: "6- Color, Orange, Red, Silver, Purple, Blue, Black",
    description: "Detachable, padded shoulder strap.  Two large side compartments.  Large front zippered pocket.  Holds up to size 15 shoes.  Removable foam ball holder.  Embroidered logos.",
    materials: "600D/840D Fabrics",
    price: 85.95,
    imgFull:"https://images.bowling.com/large/10062.large.jpg",
    imgFull2: "http://shop.bowlersparadise.com/media/extendware/ewimageopt/media/inline/10/a/brunswick-edge-single-tote-red-bowling-bag-36d.jpg"
  },

  {
    id: 2,
    bagName: "Crown Double Roller",
    warranty: "5-Year Limited Warranty",
    color: "3- Color, Silver, Royal, Red",
    description: "Premium flush retractable handle system.  5 inch urethane wheels.  Extra large pockets on both sides.  Holds up to size 17 men's shoe.  Embroidered logos.",
    materials: "600D/840D Fabrics",
    price: 115.95,
    imgFull:"https://images-na.ssl-images-amazon.com/images/I/61pcFFsP%2BQL._SY355_.jpg",
    imgFull2: "http://www.lets-bowl.co.uk/images/com_hikashop/upload/cdra3.jpg"
  },

  {
    id: 3,
    bagName: "Blitz Triple Roller",
    warranty: "5-Year Limited Warranty",
    color: "3- Color, Black, Lime, Blue",
    description: "Best in class base with flush retractable handle system.  5 inch PVC wheels.  Extra long side accessory pocket.  Full length shoe and accessory top pocket.  Screen printed logos.",
    materials: "600D Fabric",
    price: 135.95,
    imgFull:"http://lcdn.discountbowlingsupply.com/media/extendware/ewimageopt/media/inline/e/d/brunswick-blitz-triple-roller-lime-bowling-bag-401.jpg",
    imgFull2: "https://images.bowling.com/large/10046.large.jpg"
  },

];

export default bowlingBags;



// WEBPACK FOOTER //
// ./src/data/bowlingBag.js